(function () {
  document.querySelectorAll('.acc-ellaola-lp-03-offer').forEach(function (root) {
    var card = root.querySelector('.acc-ellaola-lp-03-offer__card');
    var sel = root.querySelector('.acc-ellaola-lp-03-offer__agesel');
    if (!sel || !card) return;

    var tabs = sel.querySelectorAll('.acc-ellaola-lp-03-offer__age-btn');
    var panels = root.querySelectorAll('[data-panel]');

    function set(btn) {
      if (!btn) return;
      var index = btn.getAttribute('data-index');
      var color = btn.getAttribute('data-color') || '#9a6aa6';
      card.style.setProperty('--acc-ellaola-lp-03-age', color);

      [].forEach.call(panels, function (p) {
        p.hidden = p.getAttribute('data-panel') !== index;
      });
      [].forEach.call(tabs, function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });

      // Same event the LP 01 sticky bar listens to
      document.dispatchEvent(new CustomEvent('acc-ellaola-lp-01:agechange', {
        detail: {
          url: btn.getAttribute('data-url') || '',
          now: btn.getAttribute('data-now') || '',
          old: btn.getAttribute('data-old') || '',
          color: color,
          handle: btn.getAttribute('data-handle') || ''
        }
      }));
    }

    [].forEach.call(tabs, function (b, i) {
      b.addEventListener('click', function () { set(b); });
      b.addEventListener('keydown', function (e) {
        var next = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        e.preventDefault();
        set(tabs[next]);
        tabs[next].focus();
      });
    });

    // Theme editor: selecting a tab block shows its details
    document.addEventListener('shopify:block:select', function (e) {
      if (root.contains(e.target) && e.target.classList.contains('acc-ellaola-lp-03-offer__age-btn')) set(e.target);
    });
  });
})();
